<template>
  <div>
    <pinjaman-desktop v-if="!isMobile"/>
    <pinjaman-mobile v-else/>
  </div>
</template>
<script>

import PinjamanDesktop from './Desktop/Pinjaman-Desktop.vue';
import PinjamanMobile from './Mobile/Pinjaman-Mobile.vue';
export default {
  components: {

    PinjamanDesktop,
    PinjamanMobile,
  },
    data(){
    return{
    }
  },
  


  computed:{
    isMobile(){
       if(window.innerWidth >= 500){
      return  false
    }else {
      return true
    }
    }
  }
};

</script>

<style>

</style>
